import { deepClone } from '@/server/utils';
// 定义状态常量
export const types = {
    INIT: '/user/page/formula/init',
    INPUT: '/user/page/formula/input',
    CLEAR: '/user/page/formula/clear',
    CONCAT: '/user/page/formula/concat'
};

const initState:IFormulaStoreState = {
    name: '', 
    supplier: '',
    supplierName: '',
    supplierAbbreviation: '',
    component: [{
        name: '',
        value: ''
    }],
    component2: [''],
    model: [''],
    quality: [''],
    introduction: '',
    process: '',
    guidance: '',
    labels: [],
    doc: '',
    logo: '',
    appCategory: '',
    appCateName: '',
}

const emptyState = deepClone(initState);

// 定义状态state接口
export interface IFormulaStoreState { 
    name: string; // 配方名称
    supplier: string|number; // 供应商
    supplierName: string; // 供应商名称
    supplierAbbreviation: string; // 供应商简称
    component: any[]; // 组分
    component2: string[]; // 成分
    model: string[]; // 型号
    quality: string[]; // 质量分数
    introduction: string; // 配方介绍
    process: string; // 工艺流程
    guidance: string; // 施工指导
    labels: any[]; // 标签特点
    doc: string; // 详细文档
    logo: string; // logo
    appCategory: string; // 应用分类
    appCateName: string; // 应用分类名称
}

// 定义行为action接口

export interface IFormulaAction { 
    type: string;
    data?: {
        key: string;
        value: any;
    };
    initData?: any;
    concatData?: any;
}

// 导出默认处理方法
export default (state: IFormulaStoreState = initState, action: IFormulaAction):IFormulaStoreState => { 
    switch (action.type) { 
        case types.INPUT:
            return {
                ...state,
                [action.data!.key]: action.data!.value
            }
        case types.INIT:
            if (action.initData) {
                const data = action.initData;
                if (data) {
                    return {
                        name: data.name || '', 
                        supplier: data.supplier || '',
                        supplierName: data.supplierName || '',
                        supplierAbbreviation: data.supplierAbbreviation || '',
                        component: data.component && data.component.length > 0 ? data.component : [{
                            name: '',
                            value: ''
                        }],
                        component2: data.component2 && data.component2.length > 0 ? data.component2 : [''],
                        model: data.model && data.model.length > 0 ? data.model : [''],
                        quality: data.quality && data.quality.length > 0 ? data.quality : [''],
                        introduction: data.introduction || '',
                        process: data.process || '',
                        guidance: data.guidance || '',
                        labels: data.labels || [],
                        doc: data.doc || '',
                        logo: data.logo || '',
                        appCategory: data.appCategory || '',
                        appCateName: data.appCateName || ''
                    }
                } else { 
                    return state;
                }
            } else { 
                return state;
            }
        case types.CLEAR:
            return deepClone(emptyState);
        case types.CONCAT:
            return {
                ...state,
                ...action.concatData
            }
        default:
            return state;
    }
}